let viewerWindow = null;

/**
 * Opens or reuses the single viewer browser window.
 * Falls back to window.open if the previous reference was lost or closed.
 */
export function openInViewerWindow(url) {
  try {
    if (viewerWindow && !viewerWindow.closed) {
      viewerWindow.location = url;
      viewerWindow.focus();
    } else {
      viewerWindow = window.open(url, 'viewer_window');
    }
  } catch (e) {
    // Cross-origin: reference exists but access is blocked – reopen
    viewerWindow = window.open(url, 'viewer_window');
  }
  return viewerWindow;
}

export function getViewerWindow() {
  return viewerWindow && !viewerWindow.closed ? viewerWindow : null;
}
